import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Field as HeadlessField } from '@flywire/react-headlessui';
import { cx } from '../../utils';
import { useFieldContext } from '../Field';
import { useInputClasses } from './Input';
export const useTextareaClasses = ({ className, floatingLabel = true }) => {
    return useInputClasses({
        className: cx('h-auto', className),
        floatingLabel
    });
};
const Textarea = forwardRef(({ className, ...restProps }, ref) => {
    const { floatingLabel } = useFieldContext();
    const classes = useTextareaClasses({ className, floatingLabel });
    return _jsx(HeadlessField.Textarea, { ...restProps, ref: ref, className: classes });
});
Textarea.displayName = 'Textarea';
export { Textarea };
//# sourceMappingURL=Textarea.js.map